import { RouteDtoModelType, RouteTimelineDtoModelType } from '../models';

export const getLatestStopSequence = (stopUuid: string, selectedRoute?: RouteDtoModelType, routeTimelineDtos?: RouteTimelineDtoModelType[]) => {
  const currentRouteEvent = selectedRoute?.timeline?.find((r) => r.eventUuid === stopUuid);
  if (currentRouteEvent?.stopSequence !== undefined) {
    return currentRouteEvent.stopSequence;
  }

  const matchingEvent = routeTimelineDtos
    ?.filter((r) => r.eventUuid === stopUuid)
    .sort((a, b) => (b.routeSolutionId ?? 0) - (a.routeSolutionId ?? 0) );

  return matchingEvent?.[0]?.stopSequence;
};
